import axios from 'axios'
import { gengetURLTEST, genURL } from "../../_getjson";

export default async function CheckTaxrate(code, tablename, search) {
    console.log(search);
    if (code) {
        let rs = "";
        var Url = "CSDOCGROUP/Code?tablename=" + tablename + "&code=" + code + "&user=" + localStorage.getItem("Username") + "&top=300";
        console.log("sssss", genURL(Url));
        await axios.get(genURL(Url), { timeout: 360 }).then((res) => {
            if (res.data.length === 1) {
                rs = res.data[0].TAXRATE
            }
        }).catch((err) => {
            console.log(err);
        });
        return rs
    }
};